import React, { useContext } from 'react';
import {
  Route,
  Switch,
  Redirect,
  useRouteMatch,
  useParams,
} from 'react-router-dom';

import { RootContext } from '../../layouts/RootLayout/context';
import { PageContextProvider } from './context';
import QRScannerPageContent from './content';
import QRItem from './content/QRItem';
import ProtectedRoute from '../../layouts/ProtectedRoute';

const QRScannerPage = () => {
  const { virtualPhoneNumber } = useParams();
  const { path, url } = useRouteMatch();
  const { isAuthorized } = useContext(RootContext);

  return (
    <PageContextProvider>
      <Switch>
        <Route exact path={path}>
          <QRScannerPageContent url={url} />
        </Route>
        <ProtectedRoute
          path={`${path}/:userId`}
          loggedIn={isAuthorized}
          component={QRItem}
          redirectPath={`/in/${virtualPhoneNumber}`}
        />
      </Switch>
    </PageContextProvider>
  );
};

export default QRScannerPage;
